import React, { FC, useRef } from 'react';

interface IThumbnailPhoto {
  id: number;
  thumb: string;
  link: string;
  name: string
}

export const PhotoGalleryThumbnail: FC<{
  photos: IThumbnailPhoto[];
  onView: (photos: Array<{ id: number; link: string, name: string }>) => void;
  onUpload?: (files: FileList, skuId: number, category: 'SkuBefore' | 'SkuAfter') => void;
  skuId?: number;
  category?: 'SkuBefore' | 'SkuAfter';
}> = ({ photos, onView, onUpload, skuId, category }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  
  const handleClick = () => {
    if (photos.length > 0) {
      onView(photos.map(p => ({ id: p.id, link: p.link, name: p.name })));
    }
  };
  
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files?.length || !onUpload || !skuId || !category) return;
    onUpload(e.target.files, skuId, category);
    e.target.value = '';
  };
  
  return (
    <div className="photo-gallery-thumbnail">
      <div className="thumbnail-container" onClick={handleClick}>
        {photos.length > 0 ? (
          <>
            <img src={photos[0].thumb} alt="Thumbnail" className="thumbnail-image" />
            {photos.length > 1 && (
              <div className="photo-counter">+{photos.length - 1}</div>
            )}
          </>
        ) : (
          <div className="empty-state">Нет фото</div>
        )}
      </div>
      
      {onUpload && skuId && category && (
        <div className="upload-control">
          <input
            type="file"
            multiple
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
          <button
            className="upload-button"
            onClick={() => fileInputRef.current?.click()}
          >
            Загрузить
          </button>
        </div>
      )}
    </div>
  );
};
